<template>
  <div
    class="referral-card text-left"
    @click="$router.push({ name: 'admin-referral', params: { id: referral.id } })"
  >
    <div class="card-wrapper row flex-wrap">
      <div class="col-12 col-md-8 column">
        <h1
          class="title"
          style="font-size: 0.9rem !important;"
        >
          {{ referral.title }}
        </h1>
      </div>
      <div
        class="col-12 col-md-4 column"
      >
        <div class="text-right sm-text">
          <button
            :class="referral.is_disabled ? 'btn btn-sm btn-danger' : 'btn btn-sm btn-success'"
            style="padding: 0 0.5rem;"
            @click="(e) => { e.stopPropagation(); statusClick(referral); }"
          >
            {{
              referral.is_disabled
                ? $t('cards.referral.disabled', 'Disabled')
                : $t('cards.referral.enabled', 'Active')
            }}
          </button>
        </div>
      </div>
    </div>
    <div class="card-wrapper row flex-wrap pt-2">
      <div class="col-12 col-md-7 column">
        <div class="subtitle">
          {{ $t('cards.referral.link', 'Link') }}
        </div>
        <div
          class="referral-link"
          @click="(e) => { e.stopPropagation(); }"
        >
          {{ url(referral) }}
        </div>
      </div>

      <div class="col-12 col-md-5 column sm-text">
        <div class="row">
          <div class="col-4 subtitle">
            {{ $t('cards.referral.created-at', 'Created at') }}
          </div>
          <div class="col-8">
            {{ referral.created_at }}
          </div>
        </div>
        <div class="row">
          <div class="col-4 subtitle">
            {{ $t('cards.referral.updated-at', 'Updated at') }}
          </div>
          <div class="col-8">
            {{ referral.updated_at }}
          </div>
        </div>
        <div class="row">
          <div class="col-4 subtitle">
            {{ $t('cards.referral.counter', 'Counter') }}
          </div>
          <div class="col-8">
            {{ referral.count }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      referral: {
        type: Object,
        default: null,
      },
      statusClick: {
        type: Function,
        default: null,
      }
    },

    methods: {
      // TODO: ensure this is reused somewhere somehow, this is crap
      url(referral) {
        return `${window.location.origin}/?ref=${referral.hash}`;
      },
    },
  }
</script>

<style lang="scss" scoped>
  .referral-card {
    background: white;
    padding: 15px 25px;
    margin-bottom: 0.5rem;
    transition: 0.2s ease;
    cursor: pointer;

    &:hover {
      box-shadow: 3px 3px 20px 0 rgba(210,210,210,1);
    }
  }

  .referral-link {
    background: rgba(0,0,0,0.1);
    padding-left: 3em;
    text-align: left;
    font-size: 0.8rem;
    cursor: auto;
  }

  .title {
    color: #999;
    font-size: 1rem !important;
    margin-bottom: 0;
    cursor: pointer;
  }

  .subtitle {
    color: #009090;
    font-size: 0.7rem !important;
    text-transform: uppercase;
  }

  .municipality {
    color: #777;
    font-size: 0.8rem !important;
  }

  .sm-text {
    font-size: 0.9rem;
    color: #666;
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .disabled.referral-card {
    background: #f1ebeb;
    border: 1px solid white;
  }

  .column {
    margin: auto;
  }

  .card-wrapper {
    flex-direction: row;

    @media screen and (max-width: 767px) {
      & {
        flex-direction: column;
      }

      .column {
        text-align: left;
      }
    }
  }

  .icon {
    cursor: pointer;
  }

  .card {
    background: red;
  }

  .btn-xs {
    padding: 0 0.5rem;
  }
</style>
